import React from 'react';
import { withStyles } from '@material-ui/core';
import { inject, observer} from "mobx-react";
import { compose } from "recompose";

const styles= theme => ({
    kpiContainer:{
        height: "100%",
        width: "100%",
        display: "flex"
    },
    kpiHeader:{
        display: "flex",
        fontSize: "16px",
        width: "60px",
        height: "100%",
        textAlign: "center",
        color: theme.HeaderSelectedText,
        fontWeight: 600,
        alignItems: "center",
        justifyContent: "center"
    },
    kpiPin:{
        display: "table-cell",
        fontSize: "16px",
        width: "60px",
        height: "100%",
        verticalAlign:"middle",
        textAlign: "center"
    },
    kpiContent:{
        display: "flex",
        height: "100%",
        width: 'calc(100% - 60px)',
        alignItems: "center",
        overflow: "auto",
        whiteSpace: "nowrap"
    },
    kpiValueContainer:{
        display: "inline-block",
        paddingLeft: "25px",
        paddingRight: "25px"
    },
    kpiName:{
        fontSize: "14px",
        color: theme.KPI.KPILabel
    },
    kpiValue:{
        fontSize: "16px",
        fontWeight: "bold",
        textAlign: "center",
        color: theme.KPI.KPISingleValue
    },
    kpiGoal:{
        color: theme.KPI.KPIGoalValue
    },
    kpiValueNormal:{
        color: theme.KPI.KPISingleValue
    },
    kpiValuePositive:{
        color: theme.KPI.KPIPositive
    },
    kpiValueNegative:{
        color: theme.KPI.KPINegative
    }
});
const KPIPanel = (props) => {
    const {classes} = props;
    return (
       <div className={classes.kpiContainer}>
        <div className={classes.kpiHeader}>KPI</div>
        <div className={`${classes.kpiContent} KPIContent`}>
        {props.IBPlanningStore.kpiData.map((kpi, index)=>(
            <div className={classes.kpiValueContainer} key={index}>
           {!kpi.complianceFormula?<div className={classes.kpiValue}>{kpi.value}</div>:<div className={`${classes.kpiValue} ${classes[isKPIValueComplaince(kpi)]}`}>{kpi.value} <span className={`${classes.kpiGoal} ${kpi.hideGoalValue?"hide":""}`}>/ {kpi.goal}</span></div>}
            <div className={classes.kpiName}>{kpi.kpiName}</div>
            </div>
        ))}
        </div>
        {/* TODO: Expand and Collapse behavior */}
        {/* <div className={`${classes.kpiPin} icon-icon_cancel-58`}></div> */}
       </div>
    )
};
const isKPIValueComplaince=(kpi)=>{
     if(kpi.complianceFormula!==null){
        if(kpi.complianceFormula === "G"){
           if( parseFloat(kpi.value) >= parseFloat(kpi.goal)){
               return "kpiValuePositive"
           }
           else return "kpiValueNegative"
        }
        else{
            if( parseFloat(kpi.value) > parseFloat(kpi.goal)){
                return "kpiValueNegative"
            }
            else return "kpiValuePositive"
         }
    }
    return "kpiValueNormal";
}
export default compose(withStyles(styles), inject("IBPlanningStore"))(observer(KPIPanel));